import React, {Fragment,Component} from "react";
import axios from "axios";
import exportToExcel from "../utils/ExcelUtils";

class NAB_FYPRow extends Component{
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            apiDetail: '/api/bankportal/report/detail/fyp/nab',
            reportName: 'NAB_ReportFYP',
        }
        this.onCLickToExport = this.onCLickToExport.bind(this);
        this.exportToExcel = exportToExcel.bind(this);
        this.handlerClickNode = this.props.handlerClickNode.bind(this);
        this.handlerSetIsLoading = this.props.handlerSetIsLoading.bind(this);
    }

    componentDidMount() {

    }
    onCLickToExport = (item) => {
        const payload = {
            yyyymmdd: item?.yyyymmdd,
            code: item?.code,
            type: item?.type,
            parentId: item?.parentId
        }
        /*
        const headers = {
            'Authorization': 'Bearer my-token',
            'Access-Control-Allow-Origin': true,
            'My-Custom-Header': 'foobar'
        };

         */
        const { apiDetail, reportName } = this.state;
        this.handlerSetIsLoading(true);
        axios.post(apiDetail, payload)
            .then(response => {
                let data = [];
                if(!!response.data){
                    data.push([
                        "Ngày báo cáo"
                        ,"Mã chi nhánh (FWD)"
                        ,"Mã chi nhánh (Ngân hàng)"
                        ,"Tên chi nhánh"
                        ,"Mã phòng giao dịch (FWD)"
                        ,"Mã phòng giao dịch (Ngân hàng)"
                        ,"Tên phòng giao dịch"
                        ,"Số hợp đồng"
                        ,"Mã sản phẩm"
                        ,"Tên sản phẩm"
                        ,"Tình trạng hợp đồng"
                        ,"Tên tình trạng hợp đồng"
                        ,"Loại sản phẩm"
                        ,"Số tiền bảo hiểm"
                        ,"FYP thực thu"
                        ,"FYP thực thu (trong năm)"
                        ,"Phí kỳ đầu tiên"
                        ,"Kỳ đóng phí"
                        ,"Ngày nộp"
                        ,"Ngày phát hành"
                        ,"Ngày tái phát hành"
                        ,"Ngày ký nhận thư"
                        ,"Tên khách hàng"
                        ,"Mã FSC"
                        ,"Tên FSC"
                        ,"Mã NVNH"
                        ,"Mã CBNV"
                        ,"Tên NVNH"
                        ,"Mã miền"
                        ,"Tên miền"
                        ,"Tỷ lệ hoa hồng"
                        ,"Hoa hồng tạm tính"
                        ,"Ngày ACK + 21"
                        ,"Nguồn khách hàng từ NVNH giới thiệu"
                        ,"Mã người giới thiệu"
                        ,"Mã lãnh đạo phòng"
                        ,"CBNV Ngân hàng"
                    ]);
                    response?.data.map(item =>
                        data.push([
                            item?.reportDate
                            ,item?.boCode
                            ,item?.boCodeBank
                            ,item?.boName
                            ,item?.toCode
                            ,item?.toCodeBank
                            ,item?.toName
                            ,item?.policyNumber
                            ,item?.productCode
                            ,item?.productName
                            ,item?.statusCode
                            ,item?.statusName
                            ,item?.productType
                            ,item?.sa
                            ,item?.fyp
                            ,item?.fypYtd
                            ,item?.ip
                            ,item?.premiumMode
                            ,item?.submitDate
                            ,item?.firstIssueDate
                            ,item?.issueDate
                            ,item?.ackDate
                            ,item?.poName
                            ,item?.fscCode
                            ,item?.fscName
                            ,item?.bsCode
                            ,item?.bsCodeBank
                            ,item?.bsName
                            ,item?.regionCode
                            ,item?.regionName
                            ,item?.commRate
                            ,item?.commAmount
                            ,item?.passAckDate
                            ,item?.leadSource
                            ,item?.introducerHrm
                            ,item?.hrm
                            ,item?.bsSell
                        ])
                    )
                }

                const exportName = item?.yyyymmdd+'_'+item?.code+'_'+item?.name+'_'+reportName;
                this.exportToExcel(data, exportName);
                this.handlerSetIsLoading(false);
            })
            .catch(error => {
                this.setState({ errorMessage: error.message });
                console.error('There was an error!', error);
                this.handlerSetIsLoading(false);
            });
    }
    render() {
        const {hasChild,isExpanded,marginLeftValue,data} = this.props;
        const iconStyle = {
            marginLeft: marginLeftValue+'px',
            boxShadow: 'none'
        }
        return (
            <Fragment>
            {
                !!data &&
                    <tr>
                        <td className={'bp-report-tree-node'}>
                            <button style={iconStyle} type="button" className={"btn"} onClick={this.handlerClickNode}>
                                {
                                    hasChild ?isExpanded?(' - '):(' + '):('   ')
                                }
                            </button>
                            <span>{ data?.name }</span>
                        </td>
                        <td className={"bp-report-td"}><span> { data?.c_issued?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.fyp_issued?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_issued_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.fyp_issued_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_issued_ytd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.fyp_issued_ytd?.toLocaleString() } </span></td>
                        <td className={'bp-report-button-export'}>
                            <button onClick={ () => this.onCLickToExport(data) } className={"btn btn-sm btn-info mt-1"}>Chi tiết</button>
                        </td>
                    </tr>

            }
            </Fragment>
        )
    }
}
export default NAB_FYPRow;